import { useSetLoadingPage } from 'services/UI/LoadingPage';
import { IEmailFuncType, ISMSFuncType, ISignatureActionFunc } from '../components/CustomerSignature';
import paymentApis from '../services/apis';
import { removeBase64Prefix } from 'utils/removeBase64Prefix';
import multiCardApis from '../multipleCard/services/apis';

const useSMSEmailSignature = (multiCard?: boolean) => {
  const setLoadingPage = useSetLoadingPage();
  const updateSignature = async (billId: string, signatureValue: string) => {
    if (multiCard)
      return await multiCardApis.updateSignatureForCreditCard(billId || '', removeBase64Prefix(signatureValue));
    return await paymentApis.updateSignature(billId || '', removeBase64Prefix(signatureValue));
  };

  const onNoReceipt: (billId: string, cb: () => void) => ISignatureActionFunc = (billId, cb) => async (signatureValue, args) => {
    args.close();
    if (signatureValue) {
      setLoadingPage(true);
      try {
        await updateSignature(billId || '', signatureValue);
      } catch (error) { }
      finally {
        setLoadingPage(false);
      }
    }
    cb();
  };

  const onSMS: (billId: string, cb: () => void) => ISMSFuncType = (billId, cb) => async ({ signature, phone }, args) => {
    if (!signature || !phone) return;
    setLoadingPage(true);
    try {
      await updateSignature(billId || '', signature);
      await paymentApis.sendSMSEmailReceipt(billId || '', 'SMS', phone?.replace(/[^0-9]/g, ''));
      args.close();
      cb();
    } catch (error) { }
    finally {
      setLoadingPage(false);
    }
  };

  const onEmail: (billId: string, cb: () => void) => IEmailFuncType = (billId, cb) => async ({ signature, email }, args) => {
    if (!signature || !email) return;
    setLoadingPage(true);
    try {
      await updateSignature(billId || '', signature);
      await paymentApis.sendSMSEmailReceipt(billId || '', 'EMAIL', email);
      args.close();
      cb();
    } catch (error) { }
    finally {
      setLoadingPage(false);
    }
  };
  return ({
    onNoReceipt,
    onSMS,
    onEmail,
  });
};

export default useSMSEmailSignature;
